/**
 * Scrolls selected section into view for explicit user actions only.
 *
 * Usage:
 * - Toolbar hover (to show what section will be modified)
 * - Block addition (to show the newly added block)
 * - Direct user selection (clicks, keyboard navigation)
 *
 * DO NOT use for auto-selection from scroll events - this causes scroll hijacking.
 */

export function scrollToSelectedSection(opts = { force: false }) {
  // When the mouse enters the section context toolbar, we want to ensure
  // the section is scrolled into view so that it's clear *what* section
  // the user is about to modify.
  const el = document.querySelector<HTMLDivElement>('.sales-page-active-block');
  const parent = el?.closest(
    '.overflow-auto, .salespage-wrapper, .page-editor-scroll-container',
  ) as HTMLDivElement;
  if (!el || !parent) {
    return;
  }

  // Calculate visibility of the selected section
  const elRect = el.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();

  // Check if element is completely out of view
  const isCompletelyAbove = elRect.bottom < parentRect.top;
  const isCompletelyBelow = elRect.top > parentRect.bottom;

  // Only scroll if the section is completely out of view
  // If any part of the section is visible, don't scroll - let the user stay where they are
  const shouldScroll = opts.force || isCompletelyAbove || isCompletelyBelow;

  if (shouldScroll) {
    // Smooth scroll to the new location...
    parent.scrollTo({
      // The 128 is just to give the section a little top breathing room.
      top: el.offsetTop - 128,
      behavior: 'smooth',
    });
  }
}
